import React from 'react';

import { flagStyles } from '../settings';

const SvgKR = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-2880px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgKR;
